import { create } from 'zustand'

type State = {
  open: boolean
  /** When opening from /payment/:id or /pay/internal/:id, store the full URL to feed to parse-verification-url. */
  preloadUrl: string | null
  openModal: (options?: { preloadUrl?: string }) => void
  closeModal: () => void
  /** Clear preload URL after modal has consumed it. */
  clearPreloadUrl: () => void
}

export const usePaymentModalStore = create<State>((set) => ({
  open: false,
  preloadUrl: null,
  openModal: (options) => set({ open: true, preloadUrl: options?.preloadUrl ?? null }),
  closeModal: () => set({ open: false, preloadUrl: null }),
  clearPreloadUrl: () => set((s) => ({ ...s, preloadUrl: null })),
}))
